import axios from 'axios';
import { getAuthToken, getAuthHeader } from './authService';

const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/orders/`;

export const addOrder = async (data: any) => {

    // Get the auth token
    const authToken = getAuthToken();
    // Set up the Authorization header with the Bearer token
    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': "multipart/form-data",
    };
    try {
        const response = await axios.post(`${API_URL}`, data, { headers });
        if (response.data) {

        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return null;
    }
};

export const getOrders = async (query = '') => {

    // Set up the Authorization header with the Bearer token
    const headers = getAuthHeader();
    try {
        const response = await axios.get(`${API_URL}${query ? `?${query}` : ''}`, { headers });
        if (response.data) {
            // Save token in local storage or cookie
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return [];
    }
};
export const getOrdersByQuery = async (query = '') => {

    // Set up the Authorization header with the Bearer token
    const headers = getAuthHeader();
    try {
        const response = await axios.get(`${API_URL}?${query}`, { headers });
        if (response.data) {
            // Save token in local storage or cookie
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return [];
    }
};

export const getOrder = async (id: string) => {

    // Set up the Authorization header with the Bearer token
    const headers = getAuthHeader();
    try {
        const response = await axios.get(`${API_URL}${id}`, { headers });
        if (response.data) {
            // Save token in local storage or cookie
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return [];
    }
};
export const updateOrder = async (data: any) => {

    // Get the auth token
    const authToken = getAuthToken();
    // Set up the Authorization header with the Bearer token
    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': "multipart/form-data",
    };
    try {
        const response = await axios.put(`${API_URL}${data.id}`, data, { headers });
        if (response.data) {
            console.log('updated data', response.data);
        }
        return response.data;
    } catch (error: any) {
        console.log(error.message);
        // throw error;
        return null;
    }
};
export const deleteOrder = async (id: string) => {
    // Set up the Authorization header with the Bearer token
    const headers = getAuthHeader();
    try {
        const response = await axios.put(`${API_URL}${id}/delete`, {}, { headers });
        return response.data;
    } catch (error: any) {
        const message = error.response?.data?.message || error.message;
        console.log(message);
        throw error;
    }
};

export const getOrderInvoice = async (orderId: any): Promise<any> => {
    try {
        const headers = getAuthHeader();
        const response = await axios.get(`${API_URL}${orderId}/invoice`,
            {
                headers,
                params: {
                    order_id: orderId,
                },
                responseType: 'blob',
            });
        return response.data;
    } catch (error: any) {
        throw error;
    }
};

export const getOrderDeliveryNote = async (orderId: any): Promise<any> => {
    try {
        const headers = getAuthHeader();
        const response = await axios.get(`${API_URL}${orderId}/delivery`,
            {
                headers,
                params: {
                    order_id: orderId,
                },
                responseType: 'blob',
            });
        return response.data;
    } catch (error: any) {
        throw error;
    }
};

export const updateOrderMessage = async (id: string, message: string) => {
    const headers = {
        'Authorization': `Bearer ${getAuthToken()}`,
        'Content-Type': "application/json",
    };
    try {
        const response = await axios.patch(`${API_URL}${id}`, { message }, { headers });
        return response.data;
    } catch (error: any) {
        const message = error.response?.data?.message || error.message;
        console.log(message);
        throw error;
    }
};

export const approveOrder = async (id: string) => {
    // Get the auth token
    const authToken = getAuthToken();
    // Set up the Authorization header with the Bearer token
    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': "application/json",
    };
    try {
        const response = await axios.put(`${API_URL}${id}`, { status: 'approved' }, { headers });
        if (response.data) {
            console.log('Order approved', response.data);
        }
        return response.data;
    } catch (error: any) {
        const message = error.response?.data?.message || error.message;
        // console.log(message);
        throw error;
    }
};
